import { getRegisterFunction } from '../../utils/register.js';
import { OneUxCopyElement } from './OneUxCopyElement.js';
export const register = getRegisterFunction(OneUxCopyElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-copy': OneUxCopyElement;
    "copy-d3e67246f6f6b2605eb7fbe467116fa1": OneUxCopyElement;
  }
}